import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { handleLogout } from '~/utils/handle-logout';

class ScreensLogout extends Component {

    componentDidMount = () => {
        handleLogout();
        this.props.history.push('/login');
    }

    render() {
        return (
            <div>
            </div>
        );
    }
}

export default withRouter(ScreensLogout);